<template>
    <div v-if="consultation">
        <b-modal
            :size="attachments.length > 1 ? 'xl' : 'lg'"
            v-model="modalShow"
            title="請求内容のご確認"
            ok-title="請求を確定"
            ok-variant="yokumiru-orange"
            cancel-title="戻る"
            cancel-variant="yokumiru-gray"
            :ok-disabled="inProgress || estimate === null || estimate.total < 100"
            :cancel-disabled="inProgress"
            @ok="handleOk"
            @cancel="cancel"
            @hidden="cancel">
            <form @submit.stop.prevent="storeInvoice">
                <dl>
                    <dt>{{ $locale.consultation_host }}ID</dt>
                    <dd>
                        <span>{{ `#${consultation.id}` }}</span><!--
                        --><span class="small text-muted">{{ `（${consultation.user.full_name}）` }}</span>
                    </dd>
                </dl>

                <hr style="border-style: dotted">

                <dl>
                    <dt>請求金額</dt>
                    <dd class="mb-0">
                        <template v-if="estimate">
                            <span class="lead font-weight-bold">{{ estimate.total.toLocaleString() }}</span><!--
                         --><span class="small">&nbsp;円</span><!--
                         --><span class="small text-muted">{{ `（${consultation.payment_method.name}）` }}</span>
                        </template>
                    </dd>
                    <dd>
                        <span
                            v-if="consultation.user_coupon"
                            class="small text-muted">
                            使用クーポン:&nbsp;{{ consultation.user_coupon.name }}
                        </span>
                    </dd>
                    <dd v-if="estimate && estimate.total < 100">
                        <span class="small text-danger">※請求金額が100円未満の場合は請求できません。金額を調整してください。</span>
                    </dd>
                </dl>

                <hr style="border-style: dotted">

                <dl>
                    <dt>ファイル添付</dt>
                    <dd v-if="src && src.length > 0" class="mt-3">
                        <div class="d-flex flex-wrap text-center">
                            <div
                                v-for="(s, index) in src"
                                :key="`src_${index}`"
                                :class="{ 'uploaded-item--icon' : isPDF(s.type) }"
                                class="uploaded-item">
                                <template v-if="isPDF(s.type)">
                                    <b-img
                                        :src="s.source"
                                        class="mb-1 ml-3 mr-3 uploaded-item__pdf">
                                    </b-img>
                                </template>
                                <template v-else>
                                    <b-img
                                        :src="s.source"
                                        class="mb-1 ml-3 mr-3 uploaded-item__img"
                                        thumbnail
                                        fluid>
                                    </b-img>
                                </template>
                                <div
                                    :title="s.name"
                                    class="uploaded-item__name text-muted small mb-3">
                                    {{ s.name }}
                                </div>
                            </div>
                        </div>
                    </dd>
                    <dd v-else>-</dd>
                </dl>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import constants from '../../../constants'

    const base64Encode = data =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(data)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    export default {
        name: 'ConfirmInvoiceModal',

        data: function() {
            return {
                inProgress :false,
                modalShow: false,
                consultation: null,
                userType: null,
                amount: 0,
                attachments: [],
                src: [],
                estimate: null,
                errors: {},
            }
        },

        created: function () {
            bus.$on('open-modal-confirm-invoice', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-confirm-invoice')
        },

        methods: {
            open: function (consultation, invoice, userType) {
                this.consultation = consultation
                this.amount = invoice.amount
                this.attachments = invoice.attachments
                this.userType = userType
                this.fetchEstimateManual()
                this.modalShow = true
            },

            /**
             * 請求金額
             *
             * @return {number}
             */
            fetchEstimateManual: function () {
                let endpoint = ''

                if (this.userType === 'admin') {
                    endpoint = `${constants.admin.consultations.endpoint.base}/estimate_manual?amount=${this.amount}`
                }
                else if (this.userType === 'doctor') {
                    endpoint = `${constants.doctor.consultations.endpoint.base}/estimate_manual?amount=${this.amount}`
                }

                if (this.consultation.user_coupon) {
                    endpoint += `&user_coupon_id=${this.consultation.user_coupon.id}`
                }

                axios.get(endpoint).then(({data}) => {
                    this.estimate = data.data
                })
            },

            handleOk(e) {
                e.preventDefault()
                this.storeInvoice()
            },

            storeInvoice: async function () {
                if (this.inProgress) return
                this.inProgress = true

                let endpoint = ''
                const options = {headers: {'Content-Type': 'multipart/form-data'}}

                if (this.userType === 'admin') {
                    endpoint = `${constants.admin.consultations.endpoint.base}/${this.consultation.id}/invoices`
                }
                else if (this.userType === 'doctor') {
                    endpoint = `${constants.doctor.consultations.endpoint.base}/${this.consultation.id}/invoices`
                }

                await axios.post(endpoint, this.buildFormData(), options)
                    .then(({data}) => {
                        bus.$emit('invoice-attempted', data.data)
                        bus.$emit('alert-success', '請求を行いました。')
                        this.close()
                    })
                    .catch(({response}) => {
                        if (response.hasOwnProperty('data') &&
                            response.data.hasOwnProperty('errors')) {
                            this.errors = response.data.errors
                            bus.$emit('alert-danger')
                        }
                        else {
                            bus.$emit('alert-danger', 'システムエラーが発生しました。')
                        }
                    })

                this.inProgress = false
            },

            buildFormData: function () {
                const data = new FormData()
                data.append('amount', this.amount)

                if (this.attachments.length > 0) {
                    this.attachments.forEach(attachment => {
                        data.append('attachments[]', attachment)
                    })
                }

                return data
            },

            cancel: function () {
                this.initialize()
                this.close()
            },

            close: function () {
                this.initialize()
                this.modalShow = false
            },

            initialize: function() {
                this.consultation = null
                this.amount = 0
                this.attachments = []
                this.src = []
                this.errors = {}
            },

            isPDF: function (type) {
                return type === 'application/pdf'
            },
        },

        watch: {
            attachments: function (newVal, oldVal) {
                if (!newVal || newVal === oldVal) {
                    this.src = []
                    return
                }

                newVal.forEach(attachment => {
                    if (this.isPDF(attachment.type)) {
                        this.src.push({
                            source: '/images/common/icon_pdf.svg',
                            name: attachment.name,
                            type: attachment.type,
                        })
                    }
                    else {
                        base64Encode(attachment)
                            .then(result => {
                                this.src.push({
                                    source: result,
                                    name: attachment.name,
                                    type: attachment.type,
                                })
                            })
                            .catch(() => {
                                this.src = []
                            })
                    }
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    @media only screen and (min-width: 992px) {
        .mb-errors {
            margin-bottom: 22px;
        }
    }

    .uploaded-item {
        text-align: center;

        .uploaded-item__pdf {
            width: 180px;
        }

        .uploaded-item__img {
            max-width: 400px;
        }

        .uploaded-item__name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
